import { roundToMinute } from "./roundToMinute";

// Форматирует timestamp (мс) в локальное время "ЧЧ:ММ", без секунд.
// Секунды округляются до ближайшей минуты: 30 и более — минута увеличивается
// на 1 (округление переносится и на часы/сутки, т.к. считается через Date).
export const formatClockTime = (timestampMs: number): string => {
  const date = new Date(roundToMinute(timestampMs));
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  return `${hours}:${minutes}`;
};
